import { render, staticRenderFns } from "./ProductsOnLocation.vue?vue&type=template&id=518e731a&scoped=true&"
import script from "./ProductsOnLocation.vue?vue&type=script&lang=js&"
export * from "./ProductsOnLocation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "518e731a",
  null
  
)

export default component.exports